import { render } from "./CommentCertifier.vue?vue&type=template&id=fe220bc8"
import script from "./CommentCertifier.vue?vue&type=script&lang=js"
export * from "./CommentCertifier.vue?vue&type=script&lang=js"

import "./CommentCertifier.vue?vue&type=style&index=0&id=fe220bc8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__